<template>
  <div>
    <div class="backed" v-if="formData.nodeApprStatus == 3">
      <img src="/static/err-icon.png" alt="" />
      <span class="back-title">退回原因：</span>
      <span class="back-msg">{{ formData.nodeApprOpinion }}</span>
    </div>
    <ChapterHead>
      <span v-if="formData.applyId">退补款编号：{{formData.applyId}}</span>
      <span v-else-if="formData.applyType">{{formData.applyType == '2' ? '补款协议申请' : '退款协议申请'}}</span>
      <span slot="extra">
        <span v-if="$route.params.applyId">
          <el-button type="primary" size="small" icon="el-icon-back" @click="back">返回</el-button>
        </span>
        <span v-else>{{formData.progressCodeName}}</span>
      </span>
    </ChapterHead>
    <el-form ref="formRef" :loading="loading" :model="formData" :rules="readOnly ? {} : formRules" :inline="true" label-width="180">
      <el-row>
        <el-col :span="12">
          <el-form-item label="原协议标题" prop="protocolTitle">
            <el-input type="text" disabled v-model="formData.protocolTitle" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="救助医院" prop="hospitalName">
            <el-input type="text" disabled v-model="formData.hospitalName" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="类型" prop="batchNo">
            <el-input type="text" disabled size="small" :value="formData.applyType == 2 ? '补款' : '退款'" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="原协议费用" prop="relationTotalHelpAmount">
            <el-input type="text" disabled :value="parseFloat(formData.relationTotalHelpAmount || 0).toFixed(2)" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="formData.applyType == 2 ? '补充支付' : '退还差额'" prop="totalHelpAmount">
            <el-input type="text" disabled :value="parseFloat(formData.totalHelpAmount || 0).toFixed(2)" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="患儿人次" prop="childCount">
            <el-input type="text" disabled v-model="formData.childCount" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="患儿人数" prop="childSum">
            <el-input type="text" disabled v-model="formData.childSum" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="原协议批次" prop="batchNo">
            <el-input type="text" disabled v-model="formData.batchNo" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="费用大写" prop="totalHelpAmountCn">
            <el-input type="text" disabled v-model="formData.totalHelpAmountCn" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="formData.nodeCode > 2">
        <el-col :span="12">
          <el-form-item label="协议附件" prop="attachList">
            <FileUpload v-model="formData.attachList" :disabled="true" @success="uploadScanCopy" @remove="uploadScanCopy"></FileUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <ChapterHead>辅助信息</ChapterHead>
      <!----------------------------------------- 补款协议start -------------------------------------------------------->
      <div v-if="formData.applyType == 2">
        <el-row>
          <el-col :span="6">
            <el-form-item label="申请时间" prop="createTime">
              <el-date-picker
                v-model="formData.createTime"
                size="small"
                type="date"
                placeholder="选择时间"
                :disabled="true"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收款账户" prop="accountBankNo">
              <DictionarySelect v-model="formData.accountBankNo" :disabled="readOnly || formData.nodeCode != 1 || bankAccountOptions.length == 1" :options="bankAccountOptions" @change="accountChange"></DictionarySelect>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="账户名称" prop="accountName">
              <el-input type="text" disabled v-model="formData.accountName" size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="开户网点" prop="accountBranch">
              <el-input type="text" disabled v-model="formData.accountBranch" size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.nodeCode > 4">
          <el-col :span="6">
            <el-form-item label="收到发票" prop="isReceivedBill">
              <el-radio-group v-model="formData.isReceivedBill" :disabled="readOnly || ['5', '8', '9'].indexOf(formData.nodeCode) == -1">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item v-if="formData.isReceivedBill == 1" label="收到发票时间" prop="receivedBillTime">
              <el-date-picker
                v-model="formData.receivedBillTime"
                size="small"
                type="date"
                value-format="timestamp"
                :disabled="readOnly || (formData.isReceivedBill != 1 ? true : (['5', '8', '9'].indexOf(formData.nodeCode) == -1))"></el-date-picker>
            </el-form-item>
            <el-form-item v-else label="发票时间">
              <el-input value="-" size="small" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="有无回单" prop="isBankReceipt">
              <el-radio-group v-model="formData.isBankReceipt" :disabled="readOnly || ['5', '8', '9'].indexOf(formData.nodeCode) == -1">
                <el-radio :label="1">有</el-radio>
                <el-radio :label="0">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col> -->
          <el-col :span="6" v-if="formData.nodeCode > 7">
            <el-form-item label="付款账户" prop="paymentBankId">
              <DictionarySelect v-model="formData.paymentBankId" :disabled="readOnly || formData.nodeCode != 8" :options="paymentBankAccountOptions"></DictionarySelect>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.nodeCode > 8">
          <el-col :span="6">
            <el-form-item label="是否汇款" prop="isRemit">
              <el-radio-group v-model="formData.isRemit" :disabled="true">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="汇款时间" prop="remitTime">
              <el-date-picker
                v-if="formData.remitTime"
                v-model="formData.remitTime"
                size="small"
                type="date"
                :disabled="true"></el-date-picker>
              <el-input v-else type="text" disabled value="-" size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isCWCN && formData.nodeCode >= 8">
          <el-col :span="6">
            <el-form-item label="财务经理审核">
              <el-radio-group :value="1" :disabled="true">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="理事长审核">
              <el-radio-group :value="1" :disabled="true">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!----------------------------------------- 补款协议end -------------------------------------------------------->
      <!----------------------------------------- 退款协议start -------------------------------------------------------->
      <div v-if="formData.applyType == 3">
        <el-row>
          <el-col :span="6">
            <el-form-item label="申请时间" prop="createTime">
              <el-date-picker
                v-model="formData.createTime"
                size="small"
                type="date"
                placeholder="选择时间"
                :disabled="true"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="退款账户" prop="paymentBankId">
              <DictionarySelect v-model="formData.paymentBankId" :disabled="readOnly || formData.nodeCode != 1" :options="paymentBankAccountOptions"></DictionarySelect>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="formData.nodeCode > 2">
            <el-form-item label="退款时间" prop="remitTime" :rules="[{ required: true, message: '请选择退款时间', trigger: 'change' }]">
              <el-date-picker
                v-model="formData.remitTime"
                size="small"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                :disabled="readOnly || formData.nodeCode != 3"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!----------------------------------------- 退款协议end -------------------------------------------------------->
    </el-form>
    <ChapterHead>
      <span>患儿信息</span>
      <span v-if="!readOnly && formData.nodeCode == 1" slot="extra">
        <el-button type="primary" size="small" @click="addChildOutlay">新增</el-button>
        <el-button type="primary" size="small" @click="delChildOutlay">删除</el-button>
      </span>
    </ChapterHead>
    <el-table ref="childTableRef"
      v-loading="tableLoading"
      :data="tableData"
      style="width: 100%"
      @selection-change="rowSelect"
      max-height="480px">
      <el-table-column v-if="formData.nodeCode == 1" key="selection" type="selection" width="30" align="center" label="选择"></el-table-column>
      <!-- <el-table-column key="index" type="index" width="50" label="序号" align="center"></el-table-column> -->
      <el-table-column prop="outlayId" width="145" label="费用编号" align="center">
      </el-table-column>
      <el-table-column key="childName" prop="childName" width="105" label="患儿姓名">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.childName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="birthday" prop="birthday" width="105" label="出生日期"></el-table-column>
      <el-table-column key="diseasesName" prop="diseasesName" min-width="140" label="病种">
        <template slot-scope="scope">
          <TableCellWordBreak :content="scope.row.afterDiseasesName || scope.row.beforeDiseasesName"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="curStages" prop="curStages" label="期次" width="60">
        <template slot-scope="scope">
          {{scope.row.curStages + '/' + (scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-'))}}
        </template>
      </el-table-column>
      <el-table-column prop="origihelpAmount" width="90" key="origihelpAmount" label="原救助费用" align="right">
      </el-table-column>
      <el-table-column key="realHelpAmount" prop="realHelpAmount" width="90" label="应救助金额" align="right">
        <template slot-scope="scope">
          <MoneyInput
            v-if="!readOnly && formData.nodeCode == 1"
            v-model="scope.row.realHelpAmount"
            size="mini"
            @input="calcAmount(scope.row)"/>
          <span v-else>{{parseFloat(scope.row.realHelpAmount || '0').toFixed(2)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        key="helpAmount"
        prop="helpAmount"
        width="90"
        :label="formData.applyType == 2 ? '补充支付' : '退还差额'"
        align="right">
        <template slot-scope="scope">
          <span v-if="parseFloat(scope.row.helpAmount || 0) > 0">{{parseFloat(scope.row.helpAmount || 0).toFixed(2)}}</span>
          <el-tag v-else :type="'danger'" size="mini">
            <span>{{parseFloat(scope.row.helpAmount || 0).toFixed(2)}}</span>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column key="rsReason" prop="rsReason" :label="formData.applyType == 2 ? '补款原因' : '退款原因'" align="left">
        <template slot-scope="scope">
          <el-input
            v-if="!readOnly && formData.nodeCode == 1"
            v-model="scope.row.rsReason"
            class="input-text-left"
            size="mini">
          </el-input>
          <TableCellWordBreak v-else :content="scope.row.rsReason"></TableCellWordBreak>
        </template>
      </el-table-column>
      <el-table-column key="rsReasonTmp" prop="rsReasonTmp" width="130" :label="formData.applyType == 2 ? '补款话术' : '退款话术'">
        <template slot-scope="scope">
          <DictionarySelect
            v-if="!readOnly && formData.nodeCode == 1"
            :lazy="true"
            tableCode="PROTOCOL_RS_REASON"
            class="input-text-left"
            size="mini"
            v-model="scope.row.rsReasonTmp">
          </DictionarySelect>
          <TableCellWordBreak v-else :content="scope.row.rsReasonTmpName"></TableCellWordBreak>
        </template>
      </el-table-column>
    </el-table>
    <ChapterHead>备注信息</ChapterHead>
    <el-form :inline="true">
      <el-row style="margin-bottom: 20px;">
        <el-col :span="12">
          <el-input type="textarea" :disabled="readOnly || formData.nodeCode > 4" :rows="3" v-model="formData.remark" size="small" />
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      title="治疗费用"
      :loading="dialogLoading"
      :visible.sync="cureVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="closeDialog"
      width="1200px">
        <CureOutlayDetail
          v-if="cureVisible"
          :outlayId="rowData.outlayId"
          :belongProject="rowData.initialProject"
          @close="closeDialog"
          @success="formSaveSuccess">
        </CureOutlayDetail>
    </el-dialog>
    <CheckOutlayDialog :dialogVisible.sync="checkVisible" :recordId="rowData.outlayId" @success="formSaveSuccess"></CheckOutlayDialog>
    <msgDialog
      :showErrorIcon="true"
      width="500px"
      title="提示"
      :visible.sync="confirmVisible"
      append-to-body
      @close="confirmVisible = false"
      :close-on-click-modal="false">
      <div style="font-size: 16px;">是否确认提交该协议？</div>
      <div style="padding: 20px; font-size: 16px; color: #E8556F; font-weight: bold;" v-if="confirmMsg" v-html="confirmMsg"></div>
      <div slot="footer" >
        <el-button :loading="loading" @click="confirmVisible = false">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="doComplete()">确 定</el-button>
      </div>
    </msgDialog>
    <el-dialog
      title="选择患儿"
      :visible.sync="childListVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="childListVisible = false"
      width="1200px">
      <el-table ref="childListTableRef"
        v-loading="tableLoading"
        :data="childListTableData"
        @selection-change="childListSelection"
        @row-click="toggleSelection"
        style="width: 100%"
        max-height="480px">
        <el-table-column key="selection" type="selection" width="30" align="center" label="选择"></el-table-column>
        <el-table-column prop="outlayId" width="145" label="费用编号" align="center">
        </el-table-column>
        <el-table-column key="childName" prop="childName" width="105" label="患儿姓名">
          <template slot-scope="scope">
            <TableCellWordBreak :content="scope.row.childName">
              <span>{{scope.row.childName}}</span>
            </TableCellWordBreak>
          </template>
        </el-table-column>
        <el-table-column key="birthday" prop="birthday" width="105" label="出生日期"></el-table-column>
        <el-table-column key="diseasesName" prop="diseasesName" min-width="160" label="病种">
          <template slot-scope="scope">
            <TableCellWordBreak :content="scope.row.afterDiseasesName || scope.row.beforeDiseasesName"></TableCellWordBreak>
          </template>
        </el-table-column>
        <el-table-column key="curStages" prop="curStages" label="期次" width="60">
          <template slot-scope="scope">
            {{scope.row.curStages + '/' + (scope.row.initialProject == 'AY1002' ? '-' : (scope.row.totalStages || '-'))}}
          </template>
        </el-table-column>
        <el-table-column prop="belongProjectName" width="90" key="belongProjectName" label="所属项目" align="right">
        </el-table-column>
        <el-table-column prop="helpAmount" width="90" key="helpAmount" label="救助费用" align="right">
        </el-table-column>
      </el-table>
      <div slot="footer" style="text-align: center;" >
        <el-button :loading="loading" @click="childListVisible = false">取 消</el-button>
        <el-button :loading="loading" type="primary" @click="saveChildList()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCurrentUserInfo,
  getSimpleDataById,
  selectDetailByProtocolId,
  getHospitalBankAccountList,
  getPaymentBankList,
  rsProtocolAudit,
  modifyProtocolInfo,
  selectDetailByApplyId,
  getDataByApplyId,
  submitRsProtocolInfo
} from "@/util/api.js";

import utils from '@/util/utils.js'

import ChapterHead from "@/components/business/ChapterHead";
import FileUpload from "@/components/business/FileUpload";
import MoneyInput from "@/components/business/MoneyInput";
import DictionarySelect from "@/components/business/DictionarySelect";
import msgDialog from "@/components/business/msgDialog";
import CureOutlayDetail from "@/pages/outlay/view/CureOutlayDetail";
import CheckOutlayDialog from "@/pages/outlay/view/CheckOutlayDialog";
import TableCellWordBreak from "@/components/business/TableCellWordBreak"

export default {
  components: {
    ChapterHead,
    DictionarySelect,
    TableCellWordBreak,
    FileUpload,
    MoneyInput,
    CureOutlayDetail,
    CheckOutlayDialog,
    msgDialog
  },
  props: {
    applyId: String,
    applyType: String,
    protocolId: {
      type: String
    },
    active: {
      type: String
    },
    mode: {
      type: String,
      default: 'page'
    }
  },
  data() {
    let _this = this;
    return {
      loading: false,
      readOnly: false,
      isUpload: false,
      tableLoading: false,
      dialogLoading: false,
      cureVisible: false,
      checkVisible: false,
      rollbackVisible: false,
      protocolVisible: false,
      confirmVisible: false,
      confirmMsg: null,
      isCWCN: false,
      formData: {},
      formRules: {
        accountBankNo: [{ required: true, message: '请选择收款银行账户', trigger: 'change' }],
        attachList: [{ required: true, message: '请上传协议附件', trigger: 'change' }],
        isReceivedBill: [{ required: true, message: '请选择是否收到发票', trigger: 'change' }],
        receivedBillTime: [{ required: true, message: '请选择收到发票时间', trigger: 'change' }],
        paymentBankId: [{ required: true, message: '请选择付款账户名称', trigger: 'change' }],
      },
      tableData: [],
      tableDataSelection: [],
      childListTableData: [],
      childListTableDataSelection: [],
      rowData: {},
      bankAccountOptions: [],
      paymentBankAccountOptions: [],
      childListVisible: false
    };
  },
  created () {
    this.formData.protocolId = this.$route.params.protocolId || this.protocolId;
    this.formData.applyType = this.$route.params.applyType || this.applyType;
    this.formData.applyId = this.$route.params.applyId || this.applyId;
    if (this.$route.params.readOnly) this.readOnly = this.$route.params.readOnly == 'y';
    this.isUpload = this.$route.params.upload == 'y' && this.formData.applyType == 3 ? false : this.readOnly;
  },
  mounted () {
    this.loadData();
  },
  watch: {
    protocolId () {
      this.loadData()
    }
  },
  methods: {
    loadData () {
      let request = null;
      if (this.formData.applyId) {
        // 有申请编号时，则根据申请编号查询协议信息
        request = getDataByApplyId(this.formData.applyId);
        // 查询协议详情
        this.tableLoading = true;
        selectDetailByApplyId(this.formData.applyId).then(res => {
          this.tableLoading = false;
          if (res.msgCode == 200) {
            this.tableData = res.responseData && res.responseData.map(d => {
              this.calcAmount(d);
              return d;
            });
          }
        });
      } else if (this.formData.protocolId) {
        // 新增退补款协议时没有申请编号，只有协议编号
        request = getSimpleDataById(this.formData.protocolId);
      }
      if (request) {
        request.then(res => {
          if (res.msgCode == 200) {
            if (this.formData.applyId) {
              this.formData = res.responseData;
              if (this.formData.scanCopy) {
                this.formData.attachList = this.formData.scanCopy.indexOf(',') < 0 ? [this.formData.scanCopy] : this.formData.scanCopy.split(',');
              }
              if (this.formData.totalHelpAmountCn && this.formData.totalHelpAmountCn.substring(this.formData.totalHelpAmountCn.length - 1) == '元') {
                this.formData.totalHelpAmountCn += '整';
              }
            } else {
              let createTime = new Date().getTime();
              this.formData = Object.assign(res.responseData, {
                createTime: createTime,
                applyType: this.formData.applyType,
                relationTotalHelpAmount: res.responseData.totalHelpAmount,
                totalHelpAmount: null,
                totalHelpAmountCn: '零元',
                childCount: 0,
                childSum: 0,
                nodeCode: 1,
                procInstId: null,
                accountBankNo: null,
                accountName: null,
                accountBranch: null,
                attachList: []
              });
            }
            this.$emit('loadSuccess', this.formData);

            // 查询医院账号信息
            getHospitalBankAccountList({
              searchCond: {
                hospitalId: this.formData.hospitalId,
                accountStatus: 1
              }
            }).then(bank => {
              if (bank.msgCode == 200 && bank.responseData.modelData && bank.responseData.modelData.length > 0) {
                let bankList = bank.responseData.modelData.map(b => {
                  return Object.assign({
                    valueCode: b.account,
                    valueName: b.account
                  }, b);
                });
                this.bankAccountOptions = bankList;
                if (this.bankAccountOptions.length == 1) {
                  this.$set(this.formData, 'accountBankNo', this.formData.accountBankNo || this.bankAccountOptions[0].account);
                  this.accountChange(this.formData.accountBankNo);
                }
              }
            });
  
            // 查询付款银行账号
            if ((this.formData.applyType == 2 && this.formData.nodeCode > 7) || (this.formData.applyType == 3)) {
              getPaymentBankList().then(payment => {
                if (payment.msgCode == 200) {
                  let bankList = payment.responseData.modelData.map(b => {
                    return {
                      valueCode: b.id,
                      valueName: b.bankName
                    };
                  });
                  this.paymentBankAccountOptions = bankList;
                }
              });
            }
          }
        });
      }
      // 查询当前登录用户信息
      getCurrentUserInfo().then(res => {
        if (res.msgCode == 200) {
          if (res.responseData.rolesCode && res.responseData.rolesCode.length > 0) {
            // 当前登录角色是否包含财务出纳
            let roles = res.responseData.rolesCode.filter(c => {
              return c == 'cm_pf_cwcn';
            });
            this.isCWCN = roles && roles.length > 0;
          }
        }
      });
    },
    calcAmount (row) {
      if (this.formData.applyType == 2) {
        // 补款协议
        row.realHelpAmount = row.realHelpAmount == undefined ? row.origihelpAmount + row.helpAmount : row.realHelpAmount;
        row.helpAmount = parseFloat(row.realHelpAmount - row.origihelpAmount).toFixed(2);
      } else if (this.formData.applyType == 3) {
        // 退款协议
        row.realHelpAmount = row.realHelpAmount == undefined ? row.origihelpAmount - row.helpAmount : row.realHelpAmount;
        row.helpAmount = parseFloat(row.origihelpAmount- row.realHelpAmount).toFixed(2);
      }
      // 费用计算
      if (this.tableData.length > 0) {
        if (this.tableData.length == 1) {
          this.formData.totalHelpAmount = (this.tableData[0].helpAmount || 0);
        } else {
          this.formData.totalHelpAmount = this.tableData.reduce((prev, curr) => {
            return parseFloat(prev.helpAmount || 0) + parseFloat(curr.helpAmount || 0);
          });
        }
        this.formData.totalHelpAmountCn = utils.digitUppercase(this.formData.totalHelpAmount);
      }
    },
    accountChange (val) {
      let current = this.bankAccountOptions.filter(b => {
        return b.valueCode == val;
      });
      if (current && current.length > 0) {
        this.formData.account = current[0].account;
        this.formData.accountName = current[0].accountName;
        this.formData.accountBank = current[0].accountBank;
        this.formData.accountBranch = current[0].accountBranch;
      } else {
        this.formData.account = null;
        this.formData.accountName = null;
        this.formData.accountBank = null;
        this.formData.accountBranch = null;
      }
    },
    completeProtocol () {
      this.$refs.formRef.validate((valid) => {
        if (this.formData.nodeCode == '8') {
          // 财务确认付款银行
          let paymentBankId = this.formData.paymentBankId;
          let paymentBank = this.paymentBankAccountOptions.filter(p => {
            return p.valueCode == paymentBankId
          });
          if (paymentBank == null || paymentBank.length == 0) {
            this.$message.error('请选择付款账户');
            return;
          }
          if (paymentBank[0].valueName.indexOf('支付宝') > -1) {
            if (this.formData.accountBank.indexOf('支付宝') < 0) {
              this.$message.error('付款账户不能为支付宝账户');
              return;
            }
          } else {
            if (this.formData.accountBank.indexOf('支付宝') > -1) {
              this.$message.error('付款账户只能为支付宝账户');
              return;
            }
          }
        } else if (this.formData.nodeCode == '9') {
          if (!this.formData.receivedBillTime) {
            this.$message.error('请选择收到发票时间');
              return;
          }
        }
        if (valid) {
          this.confirmMsg = '';
          // 仅在项目经理审核，即第一个节点显示该信息
          if (this.formData.nodeCode == '1') {
            if (!this.tableData || this.tableData.length == 0) {
              this.$message.error('患儿列表不能为空！');
              return;
            } else {
              // 差额非0判断
              let diffList = this.tableData.filter(d => {
                return parseFloat(d.helpAmount || 0) <= 0;
              }).map(d => {
                return d.childName;
              });
              if (diffList && diffList.length > 0) {
                let msg = '以下患儿补充支付费用小于后等于零：' + diffList.join('，');
                this.$message.error(msg);
                return;
              }
              // 补款原因或补款话术
              diffList = this.tableData.filter(d => {
                return !d.rsReason || !d.rsReasonTmp;
              }).map(d => {
                return d.childName;
              });
              if (diffList && diffList.length > 0) {
                let msg = '以下患儿补充原因或补款话术为空：' + diffList.join('，');
                this.$message.error(msg);
                return;
              }
            }
          }
          this.confirmVisible = true;
        }
      });
    },
    doComplete () {
      if (this.formData.attachList) {
        this.formData.scanCopy = this.formData.attachList.join(',');
      }
      if (this.formData.nodeCode == '1') {
        this.submitProtocol();
      } else {
        this.formData.helpList = this.tableData;
        this.$emit('beforeAudit');
        this.loading = true;
        rsProtocolAudit(Object.assign({
          operation: 'complete'
        }, this.formData)).then(res => {
          this.loading = false;
          this.$emit('completeAudit');
          if (res.msgCode == '200') {
            this.$message.success('审批成功');
            this.back();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    rowSelect (selection, row) {
      this.tableDataSelection = selection;
    },
    outlayFillIn(row) {
      this.rowData = row;
      if (this.rowData.outlayType == 1) {
        this.cureVisible = true;
        this.checkVisible = false;
      } else {
        this.cureVisible = false;
        this.checkVisible = true;
      }
      this.dialogLoading = true;
    },
    rollbackOutlaySuccess () {
      this.rollbackVisible = false;
      this.loadData();
    },
    rollbackSingleSuccess () {
      this.rollbackVisible = false;
      this.loadData();
    },
    rollbackProtocol () {
      this.protocolVisible = true;
    },
    protocolRollbackSuccess () {
      this.protocolVisible = false;
      this.back();
    },
    closeDialog () {
      this.cureVisible = false;
      this.checkVisible = false;
      this.rowData = {}
    },
    formSaveSuccess () {
      this.dialogLoading = false;
      this.closeDialog();
    },
    isOutQuota (outlay) {
      if (outlay.initialProject == 'AY1002') {
        return parseFloat(outlay.usedAmount || 0) + parseFloat(outlay.helpAmount || 0) > parseFloat(outlay.helpQuota || 0) + parseFloat(outlay.specialQuota || 0);
      } else {
        return outlay.helpAmount > (outlay.helpQuota || 0) + (outlay.specialQuota || 0);
      }
    },
    uploadScanCopy (files) {
      let scanCopy = '';
      if (files && files.length > 0) {
        scanCopy = files.join(',');
      }
      modifyProtocolInfo({
        protocolId: this.formData.protocolId,
        nodeCode: this.formData.nodeCode,
        scanCopy: scanCopy
      }).then(res => {
        if (res.msgCode == 200) {
          this.$message.success('协议扫描件保存成功！');
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    toChildInfo (row) {
      let path = this.$route.meta ? this.$route.meta.path : '/protocol/manage';
      this.$router.push({
        path: path + '/child',
        query: {
          helpId: row.helpId,
          childUid: row.childUId,
          helpReqId: row.helpReqId,
          outlayId: row.outlayId,
          nodeCode: this.readOnly ? null : this.formData.nodeCode
        }
      })
    },
    back () {
      this.$router.go(-1)
      // this.$router.push({ path: this.$route.meta.path + '?q=' + new Date().getTime() })
    },
    toggleSelection(row) {
      this.$refs.childListTableRef.toggleRowSelection(row);
    },
    addChildOutlay () {
      this.childListVisible = true;
      // 查询协议详情
      this.tableLoading = true;
      selectDetailByProtocolId(this.formData.protocolId).then(res => {
        this.tableLoading = false;
        if (res.msgCode == 200) {
          this.childListTableData = this.tableData.length == 0 ? res.responseData.map(dat => {
            dat.relationOutlayId = dat.outlayId;
            dat.origihelpAmount = dat.helpAmount;
            dat.helpAmount = null;
            return dat;
          }) : res.responseData.filter(dat => {
            dat.relationOutlayId = dat.outlayId;
            dat.origihelpAmount = dat.helpAmount;
            dat.helpAmount = null;
            return this.tableData.findIndex(rd => {
              return dat.outlayId == rd.outlayId;
            }) < 0;
          });
        }
      });

    },
    calcChildCount () {
      this.formData.childCount = this.tableData.length;
      this.formData.childSum = this.tableData.filter((item, index) => {
        return this.tableData.findIndex(res => {
          return res.childId == item.childId;
        }) == index;
      }).length;
    },
    childListSelection (selection) {
      this.childListTableDataSelection = selection;
    },
    saveChildList () {
      console.log(this.childListTableDataSelection)
      this.tableData = this.tableData.concat(this.childListTableDataSelection);
      this.calcChildCount();
      this.childListVisible = false;
    },
    delChildOutlay () {
      this.tableData = this.tableData.filter(dat => {
        return this.tableDataSelection.findIndex(rd => {
          return dat.outlayId == rd.outlayId;
        }) < 0;
      });
      this.calcChildCount();
    },
    submitProtocol () {
      this.loading = true;
      this.formData.relationProtocolId = this.formData.protocolId;
      this.formData.helpList = this.tableData;
      submitRsProtocolInfo(this.formData).then(res => {
        this.loading = false;
        if (res.msgCode == 200) {
          this.$message.success('提交成功！');
          this.back();
        } else {
          this.$message.error(res.msg);
        }
      });

    }
  }
};
</script>

<style lang="scss" scoped>
@import './../../../common/form.scss';

.backed {
  width: calc(100% - 2px);
  height: 60px;
  border: #dc243e 1px solid;
  background-color: #ffecee;
  display: flex;
  align-items: center;

  img {
    margin-left: 30px;
    width: 15px;
    height: 15px;
  }

  .back-title {
    font-weight: bold;
    font-size: 14px;
    margin: 0 10px;
  }

  .back-msg {
    font-size: 14px;
  }
}

/deep/ .applyTable .el-table__body .el-table__row {
  height: 70px;
}
/deep/ .applyTableOverFlow .el-table__body-wrapper {
  display: none;
}
/deep/ .el-table {
  .el-table-column--selection .cell {
    padding: 0px;
  }
  .el-input__inner {
    padding: 0 4px;
    text-align: right;
  }
}
.input-text-left {
  /deep/ .el-input__inner {
    padding: 0 4px;
    text-align: left !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/protocol/refund/RefundInfo.vue